// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__79Opf","list__item":"index_list__item__gAWRc"};